<template>
  <div>
    <div v-html="getThemes()"></div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {mapGetters} from "vuex";


export default {
  name: 'themes',
  components: {
  },
  methods: {
    getThemes: function() {
      let productId = this.puzzleProductId
      let str = "";
      let _themes = this.themes;
      if (this.themesByProduct[productId]) {
        this.themesByProduct[productId].forEach(function(themeId) {
          str += "<span class='theme theme-"+_themes[themeId].attributes.name+"'>"+_themes[themeId].attributes.name+"</span>";
        });
      }
      return str;
    }
  },
  created: function(){
  },
  mounted: function(){
  },
  computed: {
    ...mapState({
    }),
    ...mapGetters({
      themesByProduct: 'getPuzzleProductThemesByProduct',
      themes: 'getThemes'
    })
  },
  data: function(){
    return {
      themeColors: {
        landscape: {
          hex: "#FFCDD2",
          color: "red"
        },
        gradient: {
          color: "purple",
          hex: "#E1BEE7"
        },
        fantasy: {
          color: "deep-purple",
          hex: "#D1C4E9"
        },
        disney: {
          color: "cyan",
          hex: "#B2EBF2"
        },
        destination: {
          color: "teal",
          hex: "#B2DFDB"
        },
        finearts: {
          color: "blue-grey",
          hex: "#CFD8DC"
        },
        collage: {
          color: "blue",
          hex: "#90CAF9"
        },
        animals: {
          color: "light-blue",
          hex: "#B3E5FC"
        },
        americana: {
          color: "amber",
          hex: "#FFECB3"
        },
        holiday: {
          color: "green",
          hex: "#C8E6C9"
        },
      }
    }
  },
  watch: {
  },
  props: {
    puzzleProductId: null
  }
}
</script>
<style>

.theme {
  font-size: 13px;
  padding: 3px 7px;
  border-radius: 20px;
  margin-right: 4px;
  margin-top: 4px;
  display: inline-block;
  white-space: nowrap;
}



.theme-landscape {
  background-color: #FFCDD2;
}
.theme-gradient {
  background-color: #E1BEE7;
}
.theme-fantasy {
  background-color: #D1C4E9;
}
.theme-disney {
  background-color: #B2EBF2;
}
.theme-destination {
  background-color: #B2DFDB;
}
.theme-collage {
  background-color: #90CAF9;
}
.theme-fine {
  background-color: #C8E6C9;
}
.theme-animals {
  background-color: #B3E5FC;
}
.theme-americana {
  background-color: #FFECB3;
}
.theme-holiday {
  background-color: #CFD8DC;
}
</style>
